import { IAddressInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getGeoAddress } from './GetGeoAddress';

/**
 * Формирует текст на основе гео тегов.
 */
export function getTrapGeoTagsText(address: IAddressInfoSchema[]): string {
  const geoAddress = getGeoAddress(address);
  let text = '';

  geoAddress.map(({fullName}) => text = text.concat(`, ${fullName}`));

  return text;
}
